// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  NOTES BASED ON ACTUAL BUSINESS LOGIC:

  Base Colors:
  - Outbound: White
  - Inbound: Grey
  Status Priority: (Lowest to Highest CSS-Style Priority)
  - Curbside ONLY Inbound: Pink Revert to Grey
  - Late ONLY Outbound: Green
  - Picked Up: Revert to base color
  - Deleted: Revert to base color with a Strike-Thru Effect
  - Cancelled: Orange
  - Special: Blue
*/
.TripsTable {
  --row-color-dep: rgb(255, 255, 255);
  --row-color-arr: rgb(242, 242, 242);
  --row-color-spl: rgb(207, 231, 255);
  --row-color-late: rgb(234, 243, 191);
  --row-color-deleted: rgb(255, 255, 255);
  --row-color-cancelled: rgb(255, 216, 177);
  --row-color-curbside: rgb(255, 220, 220);
  --cell-pulse-color: rgba(197, 197, 197, 0.5);
}
.TripsTable .SimpleTable-Row.DEP {
  background-color: var(--row-color-dep);
}
.TripsTable .SimpleTable-Row.ARR {
  background-color: var(--row-color-arr);
}
.TripsTable .SimpleTable-Row:not(.PICKEDUP).DEP.LATE {
  background-color: var(--row-color-late);
}
.TripsTable .SimpleTable-Row:not(.PICKEDUP).ARR.CURBSIDE {
  background-color: var(--row-color-curbside);
}
.TripsTable .SimpleTable-Row.DEP.UPCOMING:not(.DELETED):not(.CANCELLED):not(.COMPLETED) > .UNASSIGNED, .TripsTable .SimpleTable-Row.ARR.UPCOMING:not(.DELETED):not(.CANCELLED):not(.COMPLETED) > .UNASSIGNED {
  animation: pulse 1s ease-in-out infinite !important;
}
.TripsTable .SimpleTable-Row.DEP.CANCELLED, .TripsTable .SimpleTable-Row.ARR.CANCELLED {
  background-color: var(--row-color-cancelled);
}
.TripsTable .SimpleTable-Row.DEP.DELETED:before, .TripsTable .SimpleTable-Row.ARR.DELETED:before {
  position: absolute;
  content: "";
  width: 100%;
  height: 0.5rem;
  top: calc(50% - 0.25rem);
  left: 0;
  background-color: rgba(0, 0, 0, 0.15);
  pointer-events: none;
  z-index: 1;
}
.TripsTable .SimpleTable-Row.DEP.SPL, .TripsTable .SimpleTable-Row.ARR.SPL {
  background-color: var(--row-color-spl) !important;
}
.TripsTable .SimpleTable-Row .Flags {
  position: relative;
  vertical-align: text-top;
}
.TripsTable .SimpleTable-Row .Flags > i {
  font-size: 1.25rem;
}
.TripsTable .SimpleTable-Row .Flags > i.sv-flag-filled {
  position: absolute;
  text-shadow: 1px 0 1px rgba(0, 0, 0, 0.5);
}
.TripsTable .SimpleTable-Row .Flags > .badge {
  position: absolute;
  transform: scale(0.7);
  border-radius: 50%;
}
.TripsTable .Dropdown input[name^=driver_],
.TripsTable .Dropdown input[name^=vehicle_] {
  border: none;
  background-color: transparent;
}
.TripsTable .Dropdown input[name^=driver_]:focus, .TripsTable .Dropdown input[name^=driver_]:active,
.TripsTable .Dropdown input[name^=vehicle_]:focus,
.TripsTable .Dropdown input[name^=vehicle_]:active {
  outline: none;
  border: none;
  box-shadow: none;
}
.TripsTable .Dropdown input[name^=driver_]::placeholder,
.TripsTable .Dropdown input[name^=vehicle_]::placeholder {
  color: black !important;
}
.TripsTable .SimpleTable-Footer {
  display: flex;
  gap: 1rem;
  padding: 1rem 0;
}
.TripsTable .SimpleTable-Footer button {
  width: 12rem;
}
@keyframes pulse {
  0% {
    background-color: var(--cell-pulse-color);
  }
  50% {
    background-color: transparent;
  }
  100% {
    background-color: var(--cell-pulse-color);
  }
}

@media print {
  .TripsTable .fa.fa-circle-info {
    display: none;
  }
}
.EditFcr .Fcrs {
  position: relative;
}
.EditFcr .Fcrs::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2rem;
  box-shadow: inset 0 1rem 1rem -1rem rgba(0, 0, 0, 0.35);
  z-index: 9999;
}
.EditFcr .Fcrs::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2rem;
  z-index: 9999;
  box-shadow: inset 0 -1rem 1rem -1rem rgba(0, 0, 0, 0.35);
}
.EditFcr .Fcrs .Fcrs-Scroll-Container {
  max-height: 50vh;
  overflow-y: auto;
  position: relative;
  padding: 0 1rem;
}
.EditFcr .Fcrs .Fcrs-Scroll-Container .card {
  border: 1px solid var(--bs-primary) !important;
  border-radius: 1rem;
  word-wrap: break-word;
  padding: 1rem;
  margin: 1rem 0;
}
.EditFcr .Fcrs .Fcrs-Scroll-Container .card .card-title + .card-text {
  white-space: pre-wrap;
  margin-top: 0.5rem;
}
.EditFcr .Fcrs .Fcrs-Scroll-Container .card .card-footer {
  background-color: #fff;
  border: none;
  padding: 0;
}
.EditFcr .Fcrs .Fcrs-Scroll-Container .card .card-footer .card-footer-details {
  position: relative;
  right: -1.5rem;
  bottom: -0.5rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.EditFcr .Fcrs .Fcrs-Scroll-Container .card .card-footer .card-footer-details > p {
  margin: 0;
  padding-top: 0.25rem;
}

.editCombineModal .CombineTripsTable .SimpleTable-Cell.SELECT {
  background-color: #fff;
}
.editCombineModal .CombineTripsTable .SimpleTable-Body .SimpleTable-Row {
  height: 2.5rem !important;
}
.editCombineModal .CombineTripsTable .SimpleTable-Controls {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/features/Trips/components/TripsTable/styles.scss"],"names":[],"mappings":"AAQA;;;;;;;;;;;;;CAAA;AAeA;EACE,mCAAA;EACA,mCAAA;EACA,mCAAA;EACA,oCAAA;EACA,uCAAA;EACA,yCAAA;EACA,wCAAA;EACA,4CAAA;AARF;AAYI;EACE,sCAAA;AAVN;AAaI;EACE,sCAAA;AAXN;AAkBQ;EACE,uCAAA;AAhBV;AAsBQ;EACE,2CAAA;AApBV;AA6BQ;EACE,mDAAA;AA3BV;AA+BM;EACE,4CAAA;AA7BR;AAiCQ;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;EACA,OAAA;EACA,qCAAA;EACA,oBAAA;EACA,UAAA;AA/BV;AAmCM;EACE,iDAAA;AAjCR;AAoCI;EACE,kBAAA;EACA,wBAAA;AAlCN;AAmCM;EACE,kBAAA;AAjCR;AAkCQ;EACE,kBAAA;EACA,yCAAA;AAhCV;AAmCM;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;AAjCR;AAuCI;;EAEE,YAAA;EACA,6BAAA;AArCN;AAsCM;;;EAEE,aAAA;EACA,YAAA;EACA,gBAAA;AAnCR;AAqCM;;EACE,uBAAA;AAlCR;AAuCE;EACE,aAAA;EACA,SAAA;EACA,eAAA;AArCJ;AAuCI;EACE,YAAA;AArCN;AAwCE;EACE;IACE,yCAAA;EAtCJ;EAyCE;IACE,6BAAA;EAvCJ;EA0CE;IACE,yCAAA;EAxCJ;AACF;;AA4CA;EAEI;IACE,aAAA;EA1CJ;AACF;AA+CE;EACE,kBAAA;AA7CJ;AA+CI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAEA,uDAAA;EACA,aAAA;AA9CN;AAiDI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EAEA,wDAAA;AAhDN;AAmDI;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAjDN;AAmDM;EACE,8CAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,cAAA;AAjDR;AAmDQ;EACE,qBAAA;EACA,kBAAA;AAjDV;AAoDQ;EACE,sBAAA;EACA,YAAA;EACA,UAAA;AAlDV;AAoDU;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAlDZ;AAoDY;EACE,SAAA;EACA,oBAAA;AAlDd;;AA6DI;EACE,sBAAA;AA1DN;AA6DM;EACE,yBAAA;AA3DR;AA8DI;EACE,wBAAA;AA5DN","sourcesContent":["$WHITE: rgba(255, 255, 255, 1);\n$GREY: rgba(242, 242, 242, 1);\n$BLUE: rgba(207, 231, 255, 1);\n$LIGHT_GREEN: rgba(234, 243, 191, 1);\n$LIGHT_RED: rgba(255, 220, 220, 1);\n$ORANGE: rgba(255, 216, 177, 1);\n$PULSE: rgba(197, 197, 197, 0.5);\n\n/*\n  NOTES BASED ON ACTUAL BUSINESS LOGIC:\n\n  Base Colors:\n  - Outbound: White\n  - Inbound: Grey\n  Status Priority: (Lowest to Highest CSS-Style Priority)\n  - Curbside ONLY Inbound: Pink Revert to Grey\n  - Late ONLY Outbound: Green\n  - Picked Up: Revert to base color\n  - Deleted: Revert to base color with a Strike-Thru Effect\n  - Cancelled: Orange\n  - Special: Blue\n*/\n\n.TripsTable {\n  --row-color-dep: #{$WHITE};\n  --row-color-arr: #{$GREY};\n  --row-color-spl: #{$BLUE};\n  --row-color-late: #{$LIGHT_GREEN};\n  --row-color-deleted: #{$WHITE};\n  --row-color-cancelled: #{$ORANGE};\n  --row-color-curbside: #{$LIGHT_RED};\n  --cell-pulse-color: #{$PULSE};\n\n  .SimpleTable-Row {\n    // DEPARTURE (Outbound)\n    &.DEP {\n      background-color: var(--row-color-dep);\n    }\n    // ARRIVAL (Inbound)\n    &.ARR {\n      background-color: var(--row-color-arr);\n    }\n    // NOT PICKED UP\n    &:not(.PICKEDUP) {\n      // DEPARTURE (Outbound)\n      &.DEP {\n        // LATE\n        &.LATE {\n          background-color: var(--row-color-late);\n        }\n      }\n      // ARRIVAL (Inbound)\n      &.ARR {\n        // CURBSIDE\n        &.CURBSIDE {\n          background-color: var(--row-color-curbside);\n        }\n      }\n    }\n    // OUTBOUND & INBOUND\n    &.DEP,\n    &.ARR {\n      // UPCOMING not DELETED, CANCELLED, or COMPLETED\n      &.UPCOMING:not(.DELETED):not(.CANCELLED):not(.COMPLETED) {\n        > .UNASSIGNED {\n          animation: pulse 1s ease-in-out infinite !important;\n        }\n      }\n      // CANCELLED\n      &.CANCELLED {\n        background-color: var(--row-color-cancelled);\n      }\n      // DELETED\n      &.DELETED {\n        &:before {\n          position: absolute;\n          content: '';\n          width: 100%;\n          height: 0.5rem;\n          top: calc(50% - 0.25rem);\n          left: 0;\n          background-color: rgba(0, 0, 0, 0.15); //var(--bs-secondary-subtle);\n          pointer-events: none;\n          z-index: 1;\n        }\n      }\n      // SPECIAL\n      &.SPL {\n        background-color: var(--row-color-spl) !important;\n      }\n    }\n    .Flags {\n      position: relative;\n      vertical-align: text-top;\n      > i {\n        font-size: 1.25rem;\n        &.sv-flag-filled {\n          position: absolute;\n          text-shadow: 1px 0 1px rgba(0, 0, 0, 0.5);\n        }\n      }\n      > .badge {\n        position: absolute;\n        transform: scale(0.7);\n        border-radius: 50%;\n      }\n    }\n  }\n\n  .Dropdown {\n    input[name^='driver_'],\n    input[name^='vehicle_'] {\n      border: none;\n      background-color: transparent;\n      &:focus,\n      &:active {\n        outline: none;\n        border: none;\n        box-shadow: none;\n      }\n      &::placeholder {\n        color: black !important;\n      }\n    }\n  }\n\n  .SimpleTable-Footer {\n    display: flex;\n    gap: 1rem;\n    padding: 1rem 0;\n\n    button {\n      width: 12rem;\n    }\n  }\n  @keyframes pulse {\n    0% {\n      background-color: var(--cell-pulse-color);\n    }\n\n    50% {\n      background-color: transparent;\n    }\n\n    100% {\n      background-color: var(--cell-pulse-color);\n    }\n  }\n}\n\n@media print {\n  .TripsTable {\n    .fa.fa-circle-info {\n      display: none;\n    }\n  }\n}\n\n.EditFcr {\n  .Fcrs {\n    position: relative;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 2rem;\n      // top inner box shadow\n      box-shadow: inset 0 1rem 1rem -1rem rgba(0, 0, 0, 0.35);\n      z-index: 9999;\n    }\n\n    &::after {\n      content: '';\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 2rem;\n      z-index: 9999;\n      // bottom inner box shadow\n      box-shadow: inset 0 -1rem 1rem -1rem rgba(0, 0, 0, 0.35);\n    }\n\n    .Fcrs-Scroll-Container {\n      max-height: 50vh;\n      overflow-y: auto;\n      position: relative;\n      padding: 0 1rem;\n\n      .card {\n        border: 1px solid var(--bs-primary) !important;\n        border-radius: 1rem;\n        word-wrap: break-word;\n        padding: 1rem;\n        margin: 1rem 0;\n\n        .card-title + .card-text {\n          white-space: pre-wrap;\n          margin-top: 0.5rem;\n        }\n\n        .card-footer {\n          background-color: #fff;\n          border: none;\n          padding: 0;\n\n          .card-footer-details {\n            position: relative;\n            right: -1.5rem;\n            bottom: -0.5rem;\n            display: flex;\n            justify-content: flex-end;\n            align-items: center;\n\n            > p {\n              margin: 0;\n              padding-top: 0.25rem;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.editCombineModal {\n  .CombineTripsTable {\n    .SimpleTable-Cell.SELECT {\n      background-color: #fff;\n    }\n    .SimpleTable-Body {\n      .SimpleTable-Row {\n        height: 2.5rem !important;\n      }\n    }\n    .SimpleTable-Controls {\n      display: none !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
